import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MasterRewardEditPageRoutingModule } from './master-reward-edit-routing.module';

import { MasterRewardEditPage } from './master-reward-edit.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MasterRewardEditPageRoutingModule,
    ReactiveFormsModule,
    IonicSelectableModule
  ],
  declarations: [MasterRewardEditPage]
})
export class MasterRewardEditPageModule {}
